/* VELIO One-Pager – Interaktionen (Mobile First) */
(function () {
  'use strict';

  var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ---------- Hero: Headline in Wörter zerlegen ---------- */
  document.querySelectorAll('[data-au-words]').forEach(function (el) {
    if (reduced) return;
    var nodes = Array.prototype.slice.call(el.childNodes);
    el.textContent = '';
    var i = 0;
    nodes.forEach(function (node) {
      if (node.nodeType === 3) {
        node.textContent.split(/\s+/).filter(Boolean).forEach(function (word) {
          var outer = document.createElement('span');
          outer.className = 'au-word';
          var inner = document.createElement('span');
          inner.style.setProperty('--i', i++);
          inner.textContent = word;
          outer.appendChild(inner);
          el.appendChild(outer);
          el.appendChild(document.createTextNode(' '));
        });
      } else {
        var outer = document.createElement('span');
        outer.className = 'au-word';
        var inner = document.createElement('span');
        inner.style.setProperty('--i', i++);
        inner.appendChild(node.cloneNode(true));
        outer.appendChild(inner);
        el.appendChild(outer);
        el.appendChild(document.createTextNode(' '));
      }
    });
  });

  /* ---------- Scroll-Reveal ---------- */
  var io = new IntersectionObserver(
    function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) {
          e.target.classList.add('is-in');
          io.unobserve(e.target);
        }
      });
    },
    { threshold: 0.12, rootMargin: '0px 0px -30px 0px' }
  );
  document
    .querySelectorAll('.au-reveal, .au-reveal-scale, .au-steps__row')
    .forEach(function (el) {
      io.observe(el);
    });

  /* ---------- Count-up Zahlen ---------- */
  var counterIO = new IntersectionObserver(
    function (entries) {
      entries.forEach(function (e) {
        if (!e.isIntersecting) return;
        counterIO.unobserve(e.target);
        var el = e.target;
        var raw = el.getAttribute('data-au-count');
        var decimals = (raw.split(',')[1] || '').length;
        var suffix = el.getAttribute('data-au-suffix') || '';
        var target = parseFloat(raw.replace(',', '.'));
        if (reduced) {
          el.textContent = raw + suffix;
          return;
        }
        var dur = 1600;
        var start = null;
        function step(ts) {
          if (!start) start = ts;
          var p = Math.min((ts - start) / dur, 1);
          var eased = 1 - Math.pow(1 - p, 3);
          var val = target * eased;
          el.textContent =
            (decimals ? val.toFixed(decimals).replace('.', ',') : Math.round(val)) + suffix;
          if (p < 1) requestAnimationFrame(step);
        }
        requestAnimationFrame(step);
      });
    },
    { threshold: 0.6 }
  );
  document.querySelectorAll('[data-au-count]').forEach(function (el) {
    counterIO.observe(el);
  });

  /* ---------- Wirbelsäulen-SVG: krumm -> gerade beim Scrollen ---------- */
  var spine = document.querySelector('[data-au-spine]');
  if (spine) {
    var path = spine.querySelector('.au-spine__path');
    var dots = spine.querySelectorAll('.au-spine__dot');
    var CURVED = 'M100 20 C 148 90, 152 150, 118 230 C 96 285, 92 330, 104 380';
    var STRAIGHT = 'M100 20 C 102 90, 100 150, 100 230 C 100 285, 100 330, 100 380';
    var label = spine.querySelector('.au-spine__label') ||
      spine.parentElement.querySelector('.au-spine__label');

    function lerpPath(a, b, t) {
      var na = a.match(/-?\d+(\.\d+)?/g).map(Number);
      var nb = b.match(/-?\d+(\.\d+)?/g).map(Number);
      var k = 0;
      return a.replace(/-?\d+(\.\d+)?/g, function () {
        var v = na[k] + (nb[k] - na[k]) * t;
        k++;
        return v.toFixed(1);
      });
    }

    function updateSpine() {
      var host = spine.closest('.au-problem');
      if (!host) return;
      var rect = host.getBoundingClientRect();
      var vh = window.innerHeight;
      var t = Math.min(Math.max((vh * 0.8 - rect.top) / (rect.height * 0.8), 0), 1);
      if (reduced) t = 1;
      var eased = t * t * (3 - 2 * t);
      path.setAttribute('d', lerpPath(CURVED, STRAIGHT, eased));
      dots.forEach(function (d, idx) {
        var pt = path.getPointAtLength((path.getTotalLength() / (dots.length - 1)) * idx);
        d.setAttribute('cx', pt.x);
        d.setAttribute('cy', pt.y);
      });
      if (label) label.textContent = eased > 0.85 ? 'Aufgerichtet' : 'Eingesackt';
    }
    updateSpine();
    window.addEventListener('scroll', updateSpine, { passive: true });
    window.addEventListener('resize', updateSpine);
  }

  /* ---------- Hotspots: Tap-Toggle + Caption (mobil) ---------- */
  var caption = document.querySelector('[data-au-hotcaption]');
  var hotspots = document.querySelectorAll('.au-hotspot');
  hotspots.forEach(function (hs) {
    var dot = hs.querySelector('.au-hotspot__dot');
    var card = hs.querySelector('.au-hotspot__card');
    dot.addEventListener('click', function () {
      var wasActive = hs.classList.contains('is-active');
      hotspots.forEach(function (o) {
        o.classList.remove('is-active');
        o.querySelector('.au-hotspot__dot').setAttribute('aria-expanded', 'false');
      });
      if (!wasActive) {
        hs.classList.add('is-active');
        dot.setAttribute('aria-expanded', 'true');
        if (caption && card) caption.innerHTML = card.innerHTML;
      } else if (caption) {
        caption.innerHTML = '<strong>Tipp:</strong> Punkte antippen für Details.';
      }
    });
  });

  /* ---------- Sticky Mobile-Kaufleiste ---------- */
  var bar = document.querySelector('[data-au-stickybar]');
  var buySection = document.getElementById('kaufen');
  if (bar && buySection) {
    var buyVisible = false;
    var buyIO = new IntersectionObserver(
      function (entries) {
        buyVisible = entries[0].isIntersecting;
        update();
      },
      { threshold: 0.15 }
    );
    buyIO.observe(buySection);
    function update() {
      var show = window.scrollY > window.innerHeight * 0.9 && !buyVisible;
      bar.classList.toggle('is-visible', show);
      bar.setAttribute('aria-hidden', show ? 'false' : 'true');
    }
    window.addEventListener('scroll', update, { passive: true });
    update();
  }

  /* ---------- Parallax (nur feine Pointer / Desktop) ---------- */
  var pEls = document.querySelectorAll('[data-au-parallax]');
  if (pEls.length && !reduced && window.matchMedia('(min-width: 900px)').matches) {
    var ticking = false;
    function parallax() {
      pEls.forEach(function (el) {
        var f = parseFloat(el.getAttribute('data-au-parallax')) || 0.1;
        var r = el.getBoundingClientRect();
        var offset = (r.top + r.height / 2 - window.innerHeight / 2) * f;
        el.style.transform = 'translateY(' + offset.toFixed(1) + 'px)';
      });
      ticking = false;
    }
    window.addEventListener(
      'scroll',
      function () {
        if (!ticking) {
          requestAnimationFrame(parallax);
          ticking = true;
        }
      },
      { passive: true }
    );
    parallax();
  }

  /* ---------- Kinetische Schrift (Final) ---------- */
  var kin = document.querySelectorAll('[data-au-kinetic]');
  if (kin.length && !reduced) {
    var kTicking = false;
    function kinetic() {
      var y = window.scrollY;
      kin.forEach(function (el) {
        var dir = parseFloat(el.getAttribute('data-au-kinetic')) || 1;
        el.style.transform = 'translateX(' + ((y * 0.12 * dir) % 400) * -1 + 'px)';
      });
      kTicking = false;
    }
    window.addEventListener(
      'scroll',
      function () {
        if (!kTicking) {
          requestAnimationFrame(kinetic);
          kTicking = true;
        }
      },
      { passive: true }
    );
  }

  /* ---------- FAQ Accordion ---------- */
  document.querySelectorAll('.au-qa').forEach(function (qa) {
    var btn = qa.querySelector('.au-qa__q');
    var panel = qa.querySelector('.au-qa__a');
    btn.addEventListener('click', function () {
      var open = qa.classList.contains('is-open');
      document.querySelectorAll('.au-qa.is-open').forEach(function (other) {
        if (other !== qa) {
          other.classList.remove('is-open');
          other.querySelector('.au-qa__a').style.height = '0px';
          other.querySelector('.au-qa__q').setAttribute('aria-expanded', 'false');
        }
      });
      if (open) {
        panel.style.height = panel.scrollHeight + 'px';
        requestAnimationFrame(function () {
          panel.style.height = '0px';
        });
        qa.classList.remove('is-open');
        btn.setAttribute('aria-expanded', 'false');
      } else {
        qa.classList.add('is-open');
        panel.style.height = panel.scrollHeight + 'px';
        btn.setAttribute('aria-expanded', 'true');
        panel.addEventListener(
          'transitionend',
          function () {
            if (qa.classList.contains('is-open')) panel.style.height = 'auto';
          },
          { once: true }
        );
      }
    });
  });

  /* ---------- Magnetische Buttons (nur Desktop-Pointer) ---------- */
  if (!reduced && window.matchMedia('(pointer: fine)').matches) {
    document.querySelectorAll('.au-btn').forEach(function (btn) {
      btn.addEventListener('mousemove', function (e) {
        var r = btn.getBoundingClientRect();
        var x = (e.clientX - r.left - r.width / 2) * 0.18;
        var y = (e.clientY - r.top - r.height / 2) * 0.3;
        btn.style.transform = 'translate(' + x + 'px,' + (y - 2) + 'px)';
      });
      btn.addEventListener('mouseleave', function () {
        btn.style.transform = '';
      });
    });
  }
})();
